module.exports = __webpack_public_path__ + "static/media/brands3.66ab4a00.jpg";